import * as React from 'react';


const Footer = () => (
<footer className="text-xs text-gray-500 container mx-auto mt-6">
    <p>This website is not affiliated with Facepunch Studios Ltd.
    All rights reserved. All other trademarks and copyright are acknowledged as the property of their respective owners.</p>
</footer>
);

export default Footer;